<template>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="6" fill="#DA4E4E"/>
    <line x1="3" y1="6" x2="9" y2="6" stroke="white" stroke-width="1.5"/>
    </svg>
</template>
<script>
export default { name: 'remove-response-icon' }
</script>
